<template>
  <b-form-group
    :id="'group' + id"
    :class="`text-input-group ${requireError ? 'require-field' : ''}`"
    :label="noLable ? '' : `${$translate(placeholder)} ${required ? '*' : ''}`"
    :label-for="id"
    :state="!isError"
    :invalid-feedback="errorMessage || (emailError ? textEmailError : '')"
    :style="`${typeof bottom === 'number' ? `margin-bottom:${bottom}px` : ''}`"
  >
    <div class="wrapper">
      <b-form-input
        :id="customID || id"
        :ref="id"
        v-model="text"
        :type="renderType"
        size="sm"
        trim
        :placeholder="$translate(inputPlaceholder) || $translate(placeholder)"
        :step="step"
        :state="!isError"
        :required="required"
        :disabled="disabled || viewMode"
        :class="`input ${showPasswordIcon ? 'password-icon' : ''} ${className} ${viewMode ? 'viewMode' : ''}`"
        :autocomplete="autocomplete"
        @input="updateValue"
        @focus="focused = true"
        @blur="focused = false"
      />
      <div v-if="showPasswordIcon" class="password-icon-block" @click="showPass">
        <BIconEye v-if="renderType === 'password'" />
        <BIconEyeSlash v-else />
      </div>
      <div v-if="type === 'number' && !disabled && !viewMode" class="spin-box">
        <div @click="() => handleNumber('up')">
          <ArrowDownIcon style="transform: rotate(180deg)" />
        </div>
        <div @click="() => handleNumber('down')">
          <ArrowDownIcon />
        </div>
      </div>
    </div>
    <b-form-text v-if="bottomText">
      {{ bottomText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
import { BIconEye, BIconEyeSlash } from 'bootstrap-vue';
import ArrowDownIcon from '../../../../assets/icons/iconsCode/arrow-down';

export default {
  name: 'Input',
  components: { ArrowDownIcon, BIconEye, BIconEyeSlash },
  props: {
    bottomText: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    customID: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: '1',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    tileSize: {
      type: Number,
      default: 14,
    },
    noLable: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: [Number, Boolean],
      default: false,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    updateError: {
      type: Function,
      default: () => {},
    },
    autocomplete: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {
      text: null,
      focused: false,
      renderType: '',
      showPasswordIcon: false,
      id: '',
      textEmailError: this.$translate('Invalid email address'),
    };
  },
  computed: {
    isError: function () {
      const error = this.error || this.emailError;
      this.updateError(error);
      return error;
    },
    requireError: function () {
      return this.required && !this.text;
    },
    emailError: function () {
      if (this.type !== 'email' || !this.text) {
        return false;
      }
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !re.test(String(this.text).toLowerCase());
    },
  },
  watch: {
    value(newVal) {
      this.text = newVal;
    },
  },
  created() {
    this.renderType = this.type;
  },
  mounted() {
    this.id =
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '') + new Date().getTime();
    this.text = this.value;
    this.showPasswordIcon = this.type === 'password';
  },
  methods: {
    setFocus() {
      this.$refs[this.id].$el.focus();
    },
    updateValue(value) {
      this.$emit('input', value);
      if (this.onChange) {
        this.onChange(value);
      }
    },
    handleNumber(type) {
      this.$refs[this.id].$el.focus();
      const currentNumber = Number(this.text);
      const step = Number(this.step);
      const currentValue = type === 'up'
        ? Math.round((currentNumber + step) * 1e12) / 1e12
        : Math.round((currentNumber - step) * 1e12) / 1e12;
      this.text = currentValue;
      this.updateValue(currentValue);
    },
    showPass() {
      this.renderType = this.renderType === 'text' ? 'password' : 'text';
    },
  },
};
</script>

<style scoped lang="scss">
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.spin-box {
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid #c5d0de;
  border-radius: 4px;
  color: #c5d0de;
  &:hover {
    border-color: #2260ff;
    color: #2260ff;
    & > div:first-child {
      border-color: #2260ff;
    }
  }
  & > div {
    padding: 0 12px;
    height: 50%;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
  }
  & > div:first-child {
    border-bottom: 1px solid #c5d0de;
  }
  & svg {
    width: 14px;
  }
}
::v-deep .form-control.is-valid,
::v-deep .form-control.is-invalid {
  background-image: none;
}
::v-deep .form-control {
  padding: 12px 40px 12px 12px;
  font-size: 16px;
  line-height: 20px;
  height: fit-content;
  border: 1px solid #c5d0de;
  border-radius: 4px;
}
::v-deep .form-control.is-invalid {
  border-color: #ed3232;
  background: rgba(237, 50, 50, 0.05);
  color: #ed3232;
}
::v-deep .form-control:focus {
  background: rgba(34, 96, 255, 0.02);
  border: 1px solid #2260ff;
  box-shadow: 4px 0px 16px rgba(34, 96, 255, 0.04);
  & + .spin-box {
    border-color: #2260ff;
    color: #2260ff;
    & > div:first-child {
      border-color: #2260ff;
    }
  }
}
::v-deep .d-block {
  font-size: 16px;
  line-height: 20px;
}
::v-deep .d-block.invalid-feedback {
  background: url('../../../../assets/icons/info_warning.svg') no-repeat scroll;
  background-position: left center;
  padding-left: 24px;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
}
.text-input-group.require-field,
.text-input-group.is-invalid {
  color: #ed3232;
}
.wrapper {
  display: flex;
  position: relative;
}
.text-input-group {
  position: relative;
}
.password-icon {
  padding-right: 30px;
  background: url('../../../../assets/icons/blue/view.svg') no-repeat;
  background-position: right 10px center;
}
.password-icon-block {
  width: 30px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  padding-top: 12px;
  cursor: pointer;
}
.viewMode {
  background-color: #fff !important;
}
</style>
